import { createReducer, Action, on } from '@ngrx/store';

import { IdentifierActions } from './identifier.actions';
import { IdentifierState } from './identifier.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: IdentifierState = {
  loading: false,
  identifiers: [],
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(IdentifierActions.ClearAll, (state): IdentifierState => ({ ...initialState })),
    on(
      IdentifierActions.Search,
      (state): IdentifierState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      IdentifierActions.SearchSuccess,
      (state, action): IdentifierState => ({
        ...state,
        loading: false,
        searchResult: action.result,
        identifiers: action.list,
      })
    ),
    on(
      IdentifierActions.SearchFail,
      (state, action): IdentifierState => ({
        ...state,
        loading: false,
        error: action.error,
        searchResult: undefined,
      })
    )
  )
);

export function reducer(state: IdentifierState | undefined, action: Action) {
  return featureReducer(state, action);
}
